exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.iCountUp[data-v-601075b2] {\n  font-size: 1em;\n  margin: 0;\n}\n", ""]);

